export default __webpack_public_path__ + "static/media/02.b6f96d78.jpg";